<template>
  <div ref="myDialog" class="custom-alert-pop">
    <van-popup
      v-model="vModel"
      :position="position ? position : 'center'"
      :overlay="overlay !== undefined ? overlay : true"
      :close-on-click-overlay="false"
      @close="onClose"
    >
      <div class="alert-popup-wrapper">
        <slot />
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: [
    'position',
    'overlay',
    'model'
  ],
  data() {
    return {
      vModel: this.model
    }
  },
  watch: {
    model: function(newVal) {
      this.vModel = newVal
      if (newVal !== true) return
    }
  },
  methods: {
    onClose() {
      this.$emit('alertOnClose')
    }
  }
}
</script>
<style>
.custom-alert-pop .van-popup {
  width: 90%;
  border-radius: 10px;
  opacity: 1;
}
.custom-alert-pop.fade-me-out {
  opacity: 0;
}
.custom-alert-pop .alert-popup-wrapper {
  font-size: 0.4rem;
  min-height: 2.3rem;
  /* padding-top: 0.6rem; */
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  /* padding-bottom: 0.3rem; */
}
.alert-popup-wrapper .alert-title {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  font-size: 0.35rem;
  /* text-align: left; */
  font-weight: bold;
  /* padding-left: 0.3rem; */
  border-bottom: 0.01rem solid rgba(51, 51, 51, 0.4);
}
.alert-popup-wrapper .alert-content {
  /* flex: 1; */
  /* display: flex; */
  /* flex-direction: column; */
  /* justify-content: center; */
  /* align-items: center; */
  font-size: 0.3rem;
  min-height: 1.2rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  max-height: 380px;
  overflow-y: scroll;
}

.alert-popup-wrapper .alert-bottom {
  border-top: 0.01rem solid rgba(51, 51, 51, 0.4);
  padding-top: 0.05rem;
  padding-bottom: 0.05rem;
}
.alert-popup-wrapper .alert-button {
  border: none;
  background-color: transparent;
  font-size: 0.3rem;
  color: rgb(31, 158, 219);
  padding: 0.2rem 0.4rem;
}
.alert-popup-wrapper .alert-button.alert-cancel {
  color: tomato;
}

.alert-popup-wrapper ul li {
  padding-left: 0.2rem;
  /* margin-top: 0.15rem; */
}

.alert-popup-wrapper ul.enable-list-type li {
  list-style: decimal;
}

.alert-popup-wrapper ul.enable-list-type.A li {
  list-style: upper-alpha;
}

.alert-popup-wrapper ul ul {
  margin-left: 0.4rem;
}
.alert-popup-wrapper .red {
  color: red;
}
</style>
